window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $('.btn-trigger-add').addClass('btn-alert-email');
        $('.product__outofstock').addClass('product__outofstock--visible');
        //$(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $('.btn-trigger-add').removeClass('btn-alert-email');
        $('.product__outofstock').removeClass('product__outofstock--visible');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $('#modal-outofstock').removeClass('modal--visible');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $('.btn-trigger-add').addClass('btn-alert-email');
        $('.product__outofstock').addClass('product__outofstock--visible');
        //$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.addToCartText, this.$container).html('<span class="icon-contact"><span class="path1"></span><span class="path2"></span></span> E-mail alert');
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  $('.address-add-open').on('click', function() {
    UI.$body.addClass('body-is-locked');
    UI.$html.addClass('html-is-locked');
    $newAddressForm.addClass('modal--visible');
  });

  $('.address-cancel-modal').on('click', function() {
    UI.$body.removeClass('body-is-locked');
    UI.$html.removeClass('html-is-locked');
    $(this).closest(UI.$modal).removeClass('modal--visible');
  });

  $('.address-edit-open').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).addClass('modal--visible');
  });

  $('.address-delete-open').on('click', function() {
    var formId = $(this).data('form-id');
    $('#DeleteAddress_' + formId).addClass('modal--visible');
  });

  $('.address-delete-confirm').on('click', function() {
    var formId = $(this).data('form-id');
    Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Vuarnet ================*/
var onscrollCallbacks = [],
onresizeCallbacks = [],
didScroll = false,
didResize = false;

UI = {
	init: function() {

		// Caching but nothing too specific here
		UI.$window =				$(window);
		UI.$body =					$(document.body);
		UI.$html =					$('html');
		UI.$htmlBody = 			$(document.documentElement).add(document.body);
		UI.$fields = 				$('input, textarea');
		UI.$medias = 				$('video, audio');
		UI.$video = 				$('video');
		UI.$audio = 				$('audio');

		UI.$hero = 				       	$('.fullvisual--hero');
		UI.$header = 			      	$('.page-header');
		UI.$headerMegaroll = 			$('.page-header__megaroll');
		UI.$topBar = 			       	$('.topbar');
		UI.$fullVisual = 		 			$('.fullvisual');
		UI.$offCanvas = 		 			$('.offcanvas');
		UI.$shutterOpener = 			$('a[data-opener]');
		UI.$shutterCloser = 			$('a[data-closer]');
		UI.$modal = 							$('.modal');
		UI.$overlay = 		 				$('.overlay');
		UI.$tabs = 		 						$('.tabs');
		UI.$faqItem = 						$('.faq__item');
		UI.$lensesTestView = 			$('.lenses__testview');
		UI.$productTemplate = 		$('.product__template');
		UI.$productVariants = 		$('.product__template .product__variants');
		UI.$productsSlider = 			$('.products__teasers-row--slider');
		UI.$filters =							$('.filters');
		UI.$miniFilters =					$('.minifilters');
		UI.$panelForm = 					$('.panel__form');
		UI.$form = 								$('.form');
		UI.$footer =							$('.page-footer');

		// Better scroll & resize events
		UI.$window
			.scroll(function() {	didScroll = true;	})
			.resize(function() {	didResize = true;	});

		setInterval(function() {
			if(didScroll) {
				didScroll = false;
				UI.scroll();
			}
			if(didResize) {
				didResize = false;
				UI.resize();
			}
		}, 250);

	},
	onscroll: function(callback) {
		onscrollCallbacks.push(callback);
		return UI;
	},
	onresize: function(callback) {
		onresizeCallbacks.push(callback);
		return UI;
	},
	scroll: function() {

		for(var i = 0, l = onscrollCallbacks.length; i < l; i++) {
			onscrollCallbacks[i]();
		}
	},
	resize: function() {
		for(var i = 0, l = onscrollCallbacks.length; i < l; i++) {
			onscrollCallbacks[i]();
		}
	}
};


function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		}
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	}
}

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

	UI.init();

  // Common a11y fixes
  //slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

	// Cart icon - Update cart counter
	$(document).on('cart.requestComplete', function(event, cart) {
		$('.page-header__actions-cart .page-header__actions-counter, .minicart__header-counter, .page-main__header-counter').html(cart.item_count);

		if(UI.$body.hasClass('minicart-is-opened') || UI.$body.hasClass('template-cart')) {
			return;
		} else {
			$('.page-header__actions-cart').trigger('click');
		}
	});

	// Hero
	if(UI.$hero.length) {

   	var resizeHeightSlideshow = debounce(function() {
			UI.$hero.css('height', $(window).height() - UI.$header.outerHeight());
		}, 50);

		window.addEventListener('resize', resizeHeightSlideshow);

		UI.$hero.find('.hero-content-discover').on('click', function(e) {
			e.preventDefault();

			$('html, body').animate({
				scrollTop: UI.$hero.offset().top + UI.$hero.outerHeight(true) - UI.$header.outerHeight()
			}, 700);
		});

	}

	// Full visual - Hover behavior
	if(UI.$fullVisual.length) {

    UI.$fullVisual.find('.btn').on('mouseover', function(e) {
      $(this).closest(UI.$fullVisual).addClass('fullvisual--hover');
    });

    UI.$fullVisual.find('.btn').on('mouseleave', function(e) {
    	$(this).closest(UI.$fullVisual).removeClass('fullvisual--hover');
    });

	}

	// Header - Sticky behavior
	if(UI.$topBar.length && UI.$header.length) {

		$(window).on('scroll', function(e) {
			if($(window).scrollTop() > UI.$topBar.outerHeight()) {
				UI.$body.addClass('page-header-is-sticky');
			}
			else {
				UI.$body.removeClass('page-header-is-sticky');
			}
		});

		if($(this).scrollTop() > 0) {
			UI.$body.addClass('page-header-is-sticky');
		} else {
			UI.$body.removeClass('page-header-is-sticky');
		}

	}

	// Header - Megarolls
	if(UI.$headerMegaroll.length) {

		$('.page-header__nav-item-link').on('mouseover', function(e) {

			UI.$headerMegaroll.removeClass('page-header__megaroll--opened');
			$('.page-header__nav-item').removeClass('page-header__nav-item--hover');
			UI.$body.removeClass('megaroll-is-opened');
			UI.$body.removeClass('overlay-is-visible');

			var slugMenu = $(this).attr('data-megaroll');

			if(slugMenu && $('[data-slug="'+ slugMenu +'"]').length) {
				e.preventDefault();

				$('[data-slug="'+ slugMenu +'"]').addClass('page-header__megaroll--opened');
				$(this).closest('.page-header__nav-item').addClass('page-header__nav-item--hover');
				UI.$body.addClass('megaroll-is-opened');
				UI.$body.addClass('overlay-is-visible');
			}

		});

		UI.$header.find('.page-header__megarolls').on('mouseleave', function(e) {
			UI.$headerMegaroll.removeClass('page-header__megaroll--opened');
			UI.$body.removeClass('megaroll-is-opened');
			UI.$body.removeClass('overlay-is-visible');
			$('.page-header__nav-item').removeClass('page-header__nav-item--hover');
		});

	}

	// Offcanvas
	if(UI.$offCanvas.length) {

		$('.offcanvas__nav-item--has-submenu > a').on('click', function(e) {
			e.preventDefault();

			$(this)
			.closest('.offcanvas__nav-item')
			.find('.offcanvas__nav-submenu')
			.addClass('offcanvas__nav-submenu--opened');
		});

		$('.offcanvas__nav-back').on('click', function(e) {
			e.preventDefault();

			$(this)
			.closest('.offcanvas__nav-item')
			.find('.offcanvas__nav-submenu')
			.removeClass('offcanvas__nav-submenu--opened');
		});

	}

	// Shutter - Opener
	if(UI.$shutterOpener.length) {

		UI.$shutterOpener.on('click', function(e) {
			e.preventDefault();

			var openValue = $(this).attr('data-opener');

			if(UI.$body.hasClass(openValue + '-is-opened')) {
				UI.$overlay.attr('data-overlay-from', '');
				UI.$body.removeClass('overlay-is-visible');
				UI.$body.removeClass('body-is-locked');
				UI.$html.removeClass('html-is-locked');
				UI.$body.removeClass(openValue + '-is-opened');
				$('.offcanvas__nav-submenu').removeClass('offcanvas__nav-submenu--opened');
			} else {
				UI.$overlay.attr('data-overlay-from', openValue);
				UI.$body.addClass('overlay-is-visible');
				UI.$body.addClass('body-is-locked');
				UI.$html.addClass('html-is-locked');
				UI.$body.addClass(openValue + '-is-opened');
			}

			if(openValue == 'minicart' || openValue == 'minisearch') {
				UI.$headerMegaroll.removeClass('page-header__megaroll--opened');
				$('.page-header__nav-item').removeClass('page-header__nav-item--hover');
				UI.$body.removeClass('megaroll-is-opened');
			}
		});

	}

	// Shutter - Closer
	if(UI.$shutterCloser.length) {

		UI.$shutterCloser.on('click', function(e) {
			e.preventDefault();

			var closerValue = $(this).attr('data-closer');

			UI.$overlay.attr('data-overlay-from', '');
			UI.$body.removeClass('overlay-is-visible');
			UI.$body.removeClass('body-is-locked');
			UI.$html.removeClass('html-is-locked');
			UI.$body.removeClass(closerValue + '-is-opened');
		});

	}

	// Overlay (for modal, shutter, ...)
	UI.$overlay.on('click', function(e) {
		e.preventDefault();

		var fromValue = $(this).attr('data-overlay-from');

		UI.$overlay.attr('data-overlay-from', '');
		UI.$body.removeClass('overlay-is-visible');
		UI.$body.removeClass('body-is-locked');
		UI.$html.removeClass('html-is-locked');
		UI.$body.removeClass(fromValue + '-is-opened');
		$('.offcanvas__nav-submenu').removeClass('offcanvas__nav-submenu--opened');

		UI.$body.removeClass('megaroll-is-opened');
		UI.$headerMegaroll.removeClass('page-header__megaroll--opened');
	});

	// Modal
	if(UI.$modal.length) {

		UI.$modal.find('.modal__overlay, .modal__close').on('click', function(e) {
			UI.$body.removeClass('body-is-locked');
			UI.$html.removeClass('html-is-locked');
			$(this).closest(UI.$modal).removeClass('modal--visible');
		});

	}

	// Panels
	if(UI.$panelForm.length) {

		UI.$panelForm.find('input').on('focusin', function () {
			$(this).closest('.panel').addClass('panel--focus');
			$(this).select();
		});

		UI.$panelForm.find('input').on('focusout', function () {
			$(this).closest('.panel').removeClass('panel--focus');
		});

	}

	// Footer
	if(UI.$footer.length) {

		UI.$footer.find('.page-footer__col-title').on('click', function(e) {
			e.preventDefault();

			$(this).closest('.page-footer__col').toggleClass('page-footer__col--expanded');
		});

	}

	// Product template
	if(UI.$productTemplate.length) {

		$('.product__gallery').owlCarousel({
			loop: true,
			margin: 0,
			nav: true,
			items: 1
		});

		$('.product__article-gallery').owlCarousel({
			loop: true,
			margin: 0,
			nav: false,
			items: 1
		});

		$('[data-fancybox]').fancybox({
			loop: true,
			arrows : true,

			buttons : [
				'close'
			],

			btnTpl : {
				close : '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><span class="icon-close"></span></button>',
				arrowLeft : '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><span class="icon-chevron-left"></span></button>',
				arrowRight : '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><span class="icon-chevron-right"></span></button>'
			},

			animationEffect : 'fade',
			animationDuration : 300,

			clickSlide : false,
			clickOutside : false,
		});

		$('.product__gallery .owl-item.cloned a').removeAttr('data-fancybox');

		// Product template => Variants
		if(UI.$productVariants.length) {

			$(window).on('scroll', function(e) {
				if($(window).scrollTop() < ($('.product__template').position().top + $('.product__template').outerHeight(true) - $(window).height())) {
					UI.$body.addClass('product-variants-is-sticky');
				}
				else {
					UI.$body.removeClass('product-variants-is-sticky');
				}
			});

			if($(this).scrollTop() < ($('.product__template').position().top + $('.product__template').outerHeight(true) - $(window).height())) {
				UI.$body.addClass('product-variants-is-sticky');
			}
			else {
				UI.$body.removeClass('product-variants-is-sticky');
			}

			UI.$productVariants.find('.product__variants-slider').owlCarousel({
				loop: false,
				margin: 0,
				nav: true,
				dots: false,
				autoWidth: true,
				slideBy: 3
			});

		}

		// Product template => Sizes
		if($('.product__sizes').length && $('.product__dropdown-sizes').length && $('.selector-wrapper-size').length) {

			$('.product__sizes-item').on('click', function(e) {
				e.preventDefault();

				var size = $(this).attr('data-size');

				$('.product__sizes-item').removeClass('product__sizes-item--current');
				$('.selector-wrapper-size').val(size).trigger('change');
				$('.product__dropdown-sizes-select').val(size);
				$(this).addClass('product__sizes-item--current');
			});

			$('.product__dropdown-sizes-select').on('change', function(e) {
				e.preventDefault();

				var size = $(this).val();

				$('.selector-wrapper-size').val(size).trigger('change');
				$('.product__sizes-item').removeClass('product__sizes-item--current');
				$('.product__sizes-item[data-size="'+ size +'"]').addClass('product__sizes-item--current');
			});

		}

		// Product template => Actions
		if($('.product__actions').length) {

			$('.product__actions .btn-trigger-add').on('click', function(e) {
				e.preventDefault();

				if($(this).hasClass('btn-alert-email')) {
					$('#modal-outofstock').addClass('modal--visible');
				}

				$('.product__realactions button').trigger('click');
			});

			if($('.product__actions-dropdown select').length) {

				$('.product__actions-dropdown select').on('change', function() {
					var optionId = $(this).attr('data-id');
					var currentVal = $(this).val();

					$('.product__realactions #' + optionId).val(currentVal).trigger('change');
				});

			}

		}

	}

	// Products slider
	if(UI.$productsSlider.length) {

		var sliderOptions = {
			nav: false,
			responsiveClass: true,
			responsive: {
		    0: {
					margin: 10,
					stagePadding: 30,
					items: 1,
					mouseDrag: true,
					touchDrag: true,
					pullDrag: true,
					loop: true
		    },
				768: {
					 margin: 0,
					 stagePadding: 0,
					 items: 2,
					 mouseDrag: true,
					 touchDrag: true,
					 pullDrag: true,
					 loop: true
				 },
				980: {
					margin: 0,
					stagePadding: 0,
					items: 3,
					mouseDrag: false,
					touchDrag: false,
					pullDrag: false,
					loop: false
		    }
			}
		}

		UI.$productsSlider.owlCarousel(sliderOptions);

	}

	// Tabs
	if(UI.$tabs.length) {

		UI.$tabs.zeeTab();

		UI.$tabs.find('.tabs__tab-handle').on('click', function(e) {
			e.preventDefault();

			//$('.tabs__tab').removeClass('active');
			if($(this).closest('.tabs__tab').hasClass('active')) {
				$(this).closest('.tabs__tab').removeClass('active');
			} else {
				$(this).closest('.tabs__tab').addClass('active');
			}
		});

	}

	// FAQ
	if(UI.$faqItem.length) {

		UI.$faqItem.find('.faq__question, .faq__excerpt-more').on('click', function(e) {
				e.preventDefault();

				$(this).closest('.faq__item').toggleClass('faq__item--expanded');
		});

	}

	// Lenses
	if(UI.$lensesTestView.length) {

		UI.$lensesTestView.each(function(){
			$(this).beforeAfter();
		});

	}

	// Form
	if(UI.$form.length) {

		$('.form--parsley form').parsley();

		var onClass = 'form__group--focus';
  	var showClass = 'form__group--filled';

		UI.$form.find('input, select').bind('checkval', function() {
			var formGroup = $(this).closest('.form__group');

			if(this.value !== '') {
				formGroup.addClass(showClass);
			} else {
				formGroup.removeClass(showClass);
			}

			}).on('keyup', function() {
				$(this).trigger('checkval');
			}).on('focus', function() {
				$(this).closest('.form__group').addClass(onClass);
			}).on('blur', function() {
				$(this).closest('.form__group').removeClass(onClass);
		}).trigger('checkval');

	}

	// Lazyload collections
	if(UI.$body.hasClass('template-collection') && $('.products__teaserslist--lazyload').length) {

		var itemsWrapper = '.products__teaserslist--lazyload .products__teaserslist-row';

		var manualLoadingOptions = {
			selectors: {
				itemsWrapper: itemsWrapper,
				item: '.product__teaser',
				nextPageLink: '#pagination-next',
				previousPageLink: '#pagination-previous',
				paginationWrapper: '.pagination--lazyload'
			},
			pageQueryStringKey: 'page',
			waitForImagesToBeLoaded: true,
			enablePageState: false,
			manualLoading: false,
			callBacks: {
				onAllPagesLoaded: function(){
					//$('.pagination--lazyload').css('display', 'none');
					//console.log('All pages loaded callback called...');
				},
				onPageLoad: function(items){
					//console.log("Page loaded callback called..");
				},
				beforePageLoad: function(){
					//console.log("Before page load callback called..");
				}
			}
		};

		$(itemsWrapper).t3PageLoad(manualLoadingOptions);

	}

	// Filters
	if(UI.$filters.length) {

		UI.$filters.find('.filters__dropdown-handle').on('click', function(e) {
			if($(this).closest('.filters__dropdown').hasClass('filters__dropdown--expanded')) {
				$(this).closest('.filters__dropdown').removeClass('filters__dropdown--expanded');
			} else {
				$('.filters__dropdown').removeClass('filters__dropdown--expanded');
				$(this).closest('.filters__dropdown').addClass('filters__dropdown--expanded');
			}
		});

	}

	// Minifilters
	if(UI.$miniFilters.length) {

		$('.minifilters__counter').html($('.product__teaser').length);

		UI.$miniFilters.find('.minifilters__filter-handle').on('click', function(e) {
			if($(this).closest('.minifilters__filter').hasClass('minifilters__filter--expanded')) {
				$(this).closest('.minifilters__filter').removeClass('minifilters__filter--expanded');
			} else {
				//$('.minifilters__filter').removeClass('minifilters__filter--expanded');
				$(this).closest('.minifilters__filter').addClass('minifilters__filter--expanded');
			}
		});

		Shopify.queryParams = {};

		if(location.search.length) {
			for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
				aKeyValue = aCouples[i].split('=');
				if(aKeyValue.length > 1) {
					Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
				}
			}
		}

		UI.$miniFilters.find('.minifilters__footer .btn').on('click', function(e) {
			e.preventDefault();

			delete Shopify.queryParams.page;

			var newTags = [];
			UI.$miniFilters.find('.minifilters__item input:checked').each(function() {
				if($(this).val()) {
					newTags.push($(this).val());
				}
			});

			var newURL = $(this).attr('data-url');
			if(newTags.length) {
				newURL += '/' + newTags.join('+');
			}

			var search = jQuery.param(Shopify.queryParams);
			if(search.length) {
				newURL += '?' + search;
			}

			location.href = newURL;
		});

	}

	if(localStorage.getItem('wglang')) {

		var currentLang = localStorage.getItem('wglang');
		window.Parsley.setLocale(currentLang);

	}

});
